import React from "react";
import { Modal } from "react-bootstrap";
import SaveQuoteAnalysis from "./SaveQuoteAnalysis";

export default function SaveQuote(props) {
    const closeModal = () => {
        props.fields.setModalSaveQuoteIsOpen(false);
        props.fields.setErrorMessage({ status: '', message: '' });
        props.setQuoteEmail();
    }
    return (
        <Modal 
            show={props.fields.modalSaveQuoteIsOpen} 
            className="save-term-model icon-bg" 
            onHide={() => closeModal()}
            size="md">
            <Modal.Header className="d-flex justify-content-center" closeButton>
                <Modal.Title className="modal-title">Save your Quote</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SaveQuoteAnalysis setEmailPrefill={(e) => {props.setEmailPrefill(e)}} fields={props.fields} />
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQuote.js